const SelectPropertyConstants = {
    APPLICATIONS: 'applications',
    LEASES: 'leases',
    LISTINGS: 'listings',
    PAYMENTS: 'payments',
};

export default SelectPropertyConstants;
